import { SelectedSpecialties } from '~/store/slices/filterSlice'
import { isNotNullish } from '~/utils/guards'

type HasSectionSpecialityUuid = {
    section?: {
        speciality_uuid: string
    } | null
}

export function filterBySelectedSpecialties<T extends HasSectionSpecialityUuid>(
    surgeries: readonly T[],
    selectedSpecialties: SelectedSpecialties
): readonly T[] {
    if (selectedSpecialties === 'all' || selectedSpecialties.length === 0) {
        return surgeries
    }

    return surgeries.filter(surgery => {
        const specialityUuid = surgery.section?.speciality_uuid
        return isNotNullish(specialityUuid) && selectedSpecialties.includes(specialityUuid)
    })
}
